import { React, useEffect } from "react";
import GameBoard from "../components/GameBoard";
import GameDetails from "../components/GameDetails";
import Sidebar from "../components/Sidebar";
import { useGlobalContext } from "../context";

const Chess = require("chess.js");
let chess = new Chess();

const PlayClassic = () => {
  const { setIsGameOver } = useGlobalContext();

  useEffect(() => {
    setIsGameOver(false);
  }, []);

  return (
    <main>
      <div className="section">
        <GameBoard chess={chess} />
        <GameDetails chess={chess} />
      </div>
      <Sidebar />
    </main>
  );
};

export default PlayClassic;
